import {
  Box,
  Avatar,
  Text,
  Button,
  Heading,
  useMediaQuery,
} from "@chakra-ui/react";
import {FormattedMessage, useIntl} from "react-intl";
import { useNavigate } from "react-router-dom";
import APButton from "../../../components/APButton";
import LoginDrawerSection from "./LoginDrawerSection";
import CallToLoginView from "./CallToLoginView";
import TextWithLineBreaks from "../../../components/TextWithLineBreaks";

interface ProfileViewInterface {
  profile: any;
  isLoggedIn: boolean;
  sessionData: any;
}

function ProfileView(props: ProfileViewInterface) {
  const { profile, isLoggedIn, sessionData } = props;
  const [isLargeScreen] = useMediaQuery("(min-width: 764px)");
  const intl = useIntl();

  const StatBox = ({value, title} : {value: number, title: string}) => {
    return (
      <Box
        borderRadius={12}
        textAlign={"center"}
        flex={"auto"}
        p={isLargeScreen ? 5 : 4}
        m={1}
        height={isLargeScreen ? "192px" : "152px"}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          whiteSpace: "pre-wrap",
          border: "1.5px solid #E7E1D8"
        }}
      >
        <Heading fontSize={isLargeScreen ? 50 : 28} lineHeight={1.43} fontWeight={900}>
          {value}
        </Heading>
        <Text fontSize={isLargeScreen ? 18 : 11} letterSpacing={"normal"} lineHeight={1.5}>
          <TextWithLineBreaks text={title}/>
        </Text>
      </Box>
    )}

  return (
    <Box height={"100%"} display="flex" flexDirection={"column"}>
      <Box py={6} px={4}>
        <Box
          display={"grid"}
          gridTemplateColumns="repeat(2, 1fr)"
          gridGap={0}
        >
          <StatBox value={sessionData?.sessionProblemsList.length} title={
            intl.formatMessage({
              id: 'successful-words-in-this-session',
              defaultMessage: 'Mots réussis dans cette session'
            })
          }/>
          <StatBox value={sessionData?.sessionExerciseCount} title={
            intl.formatMessage({
              id: 'word-lists-revised-in-this-session',
              defaultMessage: 'Listes de mots révisées dans cette session'
            })
          }/>
        </Box>
        {isLoggedIn ? (
          <Box
            display={"grid"}
            gridTemplateColumns="repeat(2, 1fr)"
            gridGap={0}
          >
            <StatBox value={profile?.annualProblemsList} title={
              intl.formatMessage({
                id: 'mastered-words-this-year',
                defaultMessage: 'Mots maitrisés cette année'
              })
            }/>
            <StatBox value={profile?.annualExerciseCount} title={
              intl.formatMessage({
                id: 'word-lists-revised-this-year',
                defaultMessage: 'Listes de mots révisées cette année'
              })
            } />
          </Box>
        ) : <CallToLoginView/>}
      </Box>
    </Box>
  );
}

export default ProfileView;
